import React from 'react'
import { Icon } from './QuizList.elements'

type Props = {
    className?: string
}

export const QuizListIcon = ({ className }: Props) => (
    <Icon
        aria-hidden
        className={className}
        fill="none"
        focusable={false}
        role="img"
        viewBox="0 0 24 24"
    >
        <path d="M6 8.59767H6.77133L6.91086 8.15193H7.79459L7.93413 8.59767H8.70158L7.70544 5.8457H7.00001L6 8.59767ZM7.10079 7.53564L7.34885 6.74106H7.3566L7.60467 7.53564H7.10079Z" fill="#1A1C1F"/>
        <path d="M6.21191 13.2002H7.43673C8.06077 13.2002 8.34759 12.8746 8.34759 12.425C8.34759 12.1033 8.21193 11.8397 7.7817 11.7273V11.7196C8.11891 11.5917 8.20418 11.3436 8.20418 11.1188C8.20418 10.7079 7.92511 10.4482 7.29332 10.4482H6.21191V13.2002ZM6.9251 11.5335V11.0878H7.18092C7.42123 11.0878 7.47549 11.1808 7.47549 11.3126C7.47549 11.4521 7.3941 11.5335 7.22355 11.5335H6.9251ZM6.9251 12.5684V12.0723H7.30495C7.48324 12.0723 7.58402 12.1614 7.58402 12.3165C7.58402 12.4793 7.48324 12.5684 7.30495 12.5684H6.9251Z" fill="#1A1C1F"/>
        <path d="M7.56104 17.8412C8.04942 17.8412 8.44477 17.6086 8.68121 17.3179L8.14245 16.8528C7.99516 17.0311 7.78973 17.1319 7.56104 17.1319C7.14631 17.1319 6.89825 16.8063 6.89825 16.4303C6.89825 15.9652 7.21996 15.7171 7.56104 15.7171C7.81686 15.7171 8.02617 15.8722 8.14245 16.0039L8.68121 15.5427C8.37113 15.1667 7.93702 15.0078 7.56104 15.0078C6.64243 15.0078 6.12305 15.6396 6.12305 16.4303C6.12305 17.3489 6.74708 17.8412 7.56104 17.8412Z" fill="#1A1C1F"/>
        <path d="M9.90295 6.87793H17.3469" stroke="#1A1C1F" strokeWidth="2"/>
        <path d="M9.90295 11.585H17.3469" stroke="#1A1C1F" strokeWidth="2"/>
        <path d="M9.90295 16.293H17.3469" stroke="#1A1C1F" strokeWidth="2"/>
        <mask id="path-7-inside-1" fill="white">
            <rect x="2.05811" y="1.96973" width="19.8839" height="20.0303" rx="1.65699"/>
        </mask>
        <rect x="2.05811" y="1.96973" width="19.8839" height="20.0303" rx="1.65699" stroke="#1A1C1F" strokeWidth="4" mask="url(#path-7-inside-1)"/>
    </Icon>
)
